import React, { ReactElement } from 'react';
import { Box, BulletList, BulletListContent, BulletListIcon, Li, Typography } from '@vp/swan';
import { Validation, ValidationState } from '@vp/upload-and-print-validator';
import failedValidationBullet from 'src/images/validation/failedValidationBullet.svg';
import successfulValidationBullet from 'src/images/validation/successfulValidationBullet.svg';
import unvalidatedBullet from 'src/images/validation/unvalidatedBullet.svg';
import warningValidationBullet from 'src/images/validation/warningValidationBullet.svg';
import { text } from 'src/utils/localizationUtil';

export type FileRequirementBulletProps = {
  requirement: Validation;
  isMobile: boolean;
  isValidating: boolean;
};

const BulletSvgForValidationState = (validationState: ValidationState) => {
  switch (validationState) {
    case ValidationState.Ok:
      return successfulValidationBullet;
    case ValidationState.Warning:
      return warningValidationBullet;
    case ValidationState.Error:
      return failedValidationBullet;
    case ValidationState.UnValidated:
      return unvalidatedBullet;
    default:
      return unvalidatedBullet;
  }
};

export const FileRequirementBullet = ({
  requirement,
  isMobile,
  isValidating,
}: FileRequirementBulletProps): ReactElement => {
  const bulletText = text(requirement.title, requirement.tokenValues);
  const messageText = text(requirement.message, requirement.tokenValues);

  const bullet = BulletSvgForValidationState(requirement.state);

  return (
    <>
      <BulletList>
        <Li pb={'1'}>
          <BulletListIcon src={bullet} width="32" height="32" alt="bulletIcon" />
          <BulletListContent>
            <Typography fontSize={isMobile ? 'xsmall' : 'small'}>{bulletText}</Typography>
          </BulletListContent>
        </Li>
      </BulletList>
      {!isValidating && (requirement.state === 'Error' || requirement.state === 'Warning') && messageText && (
        <Box marginLeft={'7'} style={{ marginTop: -10, paddingTop: 5 }}>
          <Typography
            fontSize={isMobile ? 'xsmall' : 'small'}
            textColor={requirement.state === 'Error' ? 'error' : 'subtle'}
          >
            {messageText}
          </Typography>
        </Box>
      )}
    </>
  );
};
